import { render, staticRenderFns } from "./listele.vue?vue&type=template&id=2d89c9d8&scoped=true"
import script from "./listele.vue?vue&type=script&lang=js"
export * from "./listele.vue?vue&type=script&lang=js"
import style0 from "./listele.vue?vue&type=style&index=0&id=2d89c9d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d89c9d8",
  null
  
)

export default component.exports